module.exports = __webpack_public_path__ + "static/media/Currrent_Game_lockup.55d082b4.png";